import { render, staticRenderFns } from "./LeaseRichEditor.vue?vue&type=template&id=1265684f&scoped=true&"
import script from "./LeaseRichEditor.vue?vue&type=script&lang=js&"
export * from "./LeaseRichEditor.vue?vue&type=script&lang=js&"
import style0 from "./LeaseRichEditor.vue?vue&type=style&index=0&id=1265684f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1265684f",
  null
  
)

export default component.exports